import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';
import SafeIcon from '../common/SafeIcon';
import { FiShield } from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="pt-24 pb-16 px-6 max-w-5xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <img 
          src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/ae915464e71886af73cf699f1c9feef1.png" 
          alt="Digital Cowboy" 
          className="h-20 md:h-24 mx-auto mb-8 object-contain" 
        />

        {/* Eyebrow */}
        <p className="font-display text-[10px] sm:text-xs uppercase tracking-wider text-dc-teal-signal mb-4">
          Digital Cowboy Memberships
        </p>

        <h1 className="text-4xl md:text-6xl font-bold text-dc-teal-deep mb-6 leading-tight">
          Choose Your Membership.<br />
          <span className="text-dc-text">Build Your Gravity.</span>
        </h1>
        
        <p className="text-lg md:text-xl text-dc-text/80 max-w-3xl mx-auto mb-4 leading-relaxed">
          Two membership paths for AI builders, consultants, service providers, and tech-forward operators. Briefing helps you learn what happened and what matters next. Build Your Network helps you meet who matters next.
        </p>

        <p className="text-lg md:text-xl font-medium text-dc-teal-deep max-w-3xl mx-auto mb-10 leading-relaxed italic">
          Projects start from partnerships. Partnerships start in smarter rooms.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Button variant="secondary" href="https://territory.digitalcowboy.io/checkout/?product_id=6405&product_type=membership">
            Get the Briefing
          </Button>
          <Button variant="primary" href="https://territory.digitalcowboy.io/checkout/?product_id=6406&product_type=membership">
            Build Your Network
          </Button>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-dc-teal-deep/80 font-medium">
          <SafeIcon icon={FiShield} className="text-dc-gold-1" />
          <p>Both memberships include a free RepUpgrade Reputation Report, valued at $199.</p>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;